import React from "react";
import { connect } from "react-redux";
import { Col, Row, Button, Modal, Dropdown, Form } from "react-bootstrap";
import { getSubscriptionDetail } from "../../../actions/SubscriptionAction";
import {
  newPaymentAction,
  updatePaymentMethodAction,
  removePaymentMethodAction,
} from "../../../actions/PaymentMethodActions";
import * as code from "../../../config/Constants";
import { toastMessage, getMonthName } from "../../Common/Common";
import { HelpOutline, Close } from "@material-ui/icons";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import AddPayment from "./AddPayment";
import { getStripeKeyAction } from "../../../actions/PaymentMethodActions";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../../config/Constants";
var CryptoJS = require("crypto-js");

//const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

class ManagePayment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      accountInfo: "",
      cancelPrompt: false,
      paymentModal: false,
      paymentMethodId: "",
      stripePromise: "",
    };
  }
  componentWillMount() {
    this.getReactAppStripeKey();
    this.getSubscriptionDetail();
  }

  getReactAppStripeKey() {
    this.setState({ showLoader: true });
    this.props.getStripeKeyAction().then((res) => {
      //console.log('getReactAppStripeKey getStripeKeyAction res',res);
      this.setState({ showLoader: false });
      if (res.status === code.OK) {
        var sKey = res.data;
        //console.log('getReactAppStripeKey OK sKey', sKey);
        let bytes = CryptoJS.AES.decrypt(sKey, REACT_APP_CRYPTO_SECRET_KEY);
        //console.log('getReactAppStripeKey OK bytes', bytes);
        let decryptedDataKey = bytes.toString(CryptoJS.enc.Utf8);
        //console.log('decryptedDataKey',decryptedDataKey);
        let stripePromise = loadStripe(decryptedDataKey);
        this.setState({ stripePromise });
      }
    });
  }

  getSubscriptionDetail() {
    this.setState({ showLoader: true });
    this.props.getSubscriptionDetail().then((res) => {
      this.setState({ showLoader: false });
      if (res.status === code.OK) {
        this.setState({ accountInfo: res.data });
      }
    });
  }
  setPaymentModal() {
    this.setState({ paymentModal: !this.state.paymentModal });
  }

  addNewPaymentMethod(paymentId) {
    this.setState({ showLoader: true });
    this.setPaymentModal();
    let data = {
      paymentMethodId: paymentId,
    };
    this.props.newPaymentAction(data).then((res) => {
      this.setState({ showLoader: false });
      if (res.status === code.OK) {
        toastMessage(code.SUCCESS, "New card added successfully");
        this.getSubscriptionDetail();
      } else {
        toastMessage(code.ERROR, res.data);
      }
    });
  }

  updatePaymentMethod(paymentId) {
    this.setState({ showLoader: true });
    let data = {
      paymentMethodId: paymentId,
    };
    this.props.updatePaymentMethodAction(data).then((res) => {
      this.setState({ showLoader: false });
      if (res.status === code.OK) {
        toastMessage(code.SUCCESS, "Updated successfully");
        this.getSubscriptionDetail();
      }
    });
  }
  deletePaymentMethod() {
    this.setState({ showLoader: true });
    let data = {
      paymentMethodId: this.state.paymentMethodId,
    };
    this.props.removePaymentMethodAction(data).then((res) => {
      this.cancelPrompt();
      this.setState({ showLoader: false });
      if (this.props.isPaymentDeleted) {
        toastMessage(code.SUCCESS, "Payment method deleted");
        this.getSubscriptionDetail();
      }
    });
  }
  /**
   * @desc open/close cancel promt
   */
  cancelPrompt() {
    this.setState({
      cancelPrompt: !this.state.cancelPrompt,
    });
  }
  render() {
    if (this.state.showLoader) {
      return (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <>
          <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
            <Col className="col-auto" xs={12} sm={7}>
              <h4 className="title-med mt-0 pt-1">Payment methods</h4>
            </Col>

            <Col className="col-auto text-right" xs={12} sm={4}>
              <Form.Group controlId="" className="mb-0">
                <Button
                  variant="primary"
                  className="btn-blue btn-head hide-767"
                  onClick={() => this.setPaymentModal()}
                >
                  Add Payment Method
                </Button>
              </Form.Group>
            </Col>
          </Row>

          <div className="subscription-detail master-template-container">
            <div className="manage-payment">
              {!!this.state.accountInfo.paymentMethods
                ? this.state.accountInfo.paymentMethods.map((card) => {
                    return (
                      <Row className="manage-payment-row mb-3">
                        <Col sm={8}>
                          <ul className="cc-info">
                            <li className="generic_card">
                              <p className="cc-vendor">
                                {card.brand}&nbsp;{"****" + card.number}
                              </p>
                              <p className="cc-expiry">
                                Expires {getMonthName(card.expireMonth - 1)}
                                &nbsp;{card.expireYear}{" "}
                              </p>
                            </li>
                          </ul>
                        </Col>
                        <Col sm={3}>
                          {!card.isDefault ? (
                            <span
                              onClick={() =>
                                this.updatePaymentMethod(card.paymentMethodId)
                              }
                              className="set-default"
                            >
                              Set as default
                            </span>
                          ) : (
                            <span>Default</span>
                          )}
                        </Col>
                        <Col sm={1}>
                          {!card.isDefault ? (
                            <span
                              onClick={() => {
                                this.setState({
                                  cancelPrompt: true,
                                  paymentMethodId: card.paymentMethodId,
                                });
                              }}
                              className="fa fa-trash"
                              aria-hidden="true"
                            />
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    );
                  })
                : ""}
            </div>

            <Modal
              show={this.state.paymentModal}
              onHide={() => this.setPaymentModal()}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med1 add-payment-method"
            >
              <Form className="form-sm form-admin">
                <Modal.Header closeButton>
                  <Modal.Title id="example-custom-modal-styling-title">
                    Card Details
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col xs={12}>
                      <Elements stripe={this.state.stripePromise}>
                        <AddPayment
                          addNewPaymentMethod={(id) =>
                            this.addNewPaymentMethod(id)
                          }
                          setPaymentModal={() => this.setPaymentModal()}
                        />
                      </Elements>
                    </Col>
                  </Row>
                </Modal.Body>
              </Form>
            </Modal>
            <Modal
              show={this.state.cancelPrompt}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
              className="modal-med modal-400 modal-delete"
              centered
              backdrop={false}
            >
              <Modal.Body className="pb-0 text-center">
                <HelpOutline />
                <p>Are you sure you want to delete payment method?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  className="btn-blue btn-outlined w-140"
                  onClick={() => {
                    this.cancelPrompt();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  className="btn-blue w-140"
                  onClick={() => {
                    this.deletePaymentMethod();
                  }}
                >
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    accountInfo: state.reducer.accountInfo,
    isPaymentDeleted: state.reducer.isPaymentDeleted,
  };
};
export default connect(
  mapStateToProps,
  {
    getSubscriptionDetail,
    newPaymentAction,
    updatePaymentMethodAction,
    removePaymentMethodAction,
    getStripeKeyAction,
  }
)(ManagePayment);
